const CHAVE_SESSAO = 'funil:idSessao';
const DEBOUNCE_MS = 2000;
// O servidor aceita até 50 eventos por envio: filas maiores vão em pedaços.
const MAXIMO_POR_ENVIO = 50;

type EventoFila = { evento: string; propriedades?: string; ocorridoEm: string };

let fila: EventoFila[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;
let unloadRegistrado = false;

const gerarUuid = (): string => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

export const obterTokenFunil = (): string | null => {
    try {
        const persistido = localStorage.getItem('persist:locasmartpro');
        if (!persistido) return null;
        const dados = JSON.parse(persistido);
        return dados.token ? dados.token.replaceAll('"', '') : null;
    } catch {
        return null;
    }
};

export const iniciarSessaoFunil = (): string => {
    let idSessao = sessionStorage.getItem(CHAVE_SESSAO);
    if (!idSessao) {
        idSessao = gerarUuid();
        sessionStorage.setItem(CHAVE_SESSAO, idSessao);
    }
    return idSessao;
};

export const enviarFilaFunil = (): void => {
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
    if (fila.length === 0) return;
    const token = obterTokenFunil();
    if (!token) {
        fila = [];
        return;
    }
    const pendentes = fila.splice(0, fila.length);
    for (let i = 0; i < pendentes.length; i += MAXIMO_POR_ENVIO) {
        const eventos = pendentes.slice(i, i + MAXIMO_POR_ENVIO);
        try {
            fetch(`${process.env.REACT_APP_API_URL}/EventoFunil`, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ idSessao: iniciarSessaoFunil(), eventos }),
            }).catch(() => { /* telemetria nunca afeta a UX */ });
        } catch { /* telemetria nunca afeta a UX */ }
    }
};

export const rastrearEventoFunil = (
    evento: string,
    propriedades?: Record<string, unknown>,
    opcoes?: { coalescer?: boolean }
): void => {
    try {
        if (!unloadRegistrado) {
            window.addEventListener('pagehide', enviarFilaFunil);
            unloadRegistrado = true;
        }
        if (opcoes?.coalescer) {
            fila = fila.filter(e => e.evento !== evento);
        }
        fila.push({
            evento,
            propriedades: propriedades ? JSON.stringify(propriedades) : undefined,
            // Hora em que aconteceu, não a do envio em lote (o servidor antigo ignora o campo).
            ocorridoEm: new Date().toISOString(),
        });
        if (timer) clearTimeout(timer);
        timer = setTimeout(enviarFilaFunil, DEBOUNCE_MS);
    } catch { /* telemetria nunca afeta a UX */ }
};
